import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: ${(props) => (props.isTeamProfile ? "calc(100%)" : "100vw")};
  min-height: 85vh;
  position: relative;
  padding-bottom: 3rem;
  .gameContainer {
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: ${(props) => (props.isTeamProfile ? "0 10px" : "10px")};
    border-bottom: 1px solid #ccc;
    border-radius: 5px;
    width: 90%;
    margin: 0 auto;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .league-logo {
        width: 40px;
        height: auto;
      }
      .game-information {
        text-align: center;
        margin-left: 0;
        .date {
          font-weight: 700;
        }
      }

      .game-information,
      .link-container {
        flex: 1;
        text-align: flex-start;
      }
      .game-result {
        width: 40px;
        height: 40px;
        background: #001838;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        &.green {
          background: #6cd5a6;
          p {
            color: #001838;
          }
        }
        p {
          font-weight: 700;
          color: #fff;
        }
      }
    }
    .content {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: ${(props) =>
        props.isTeamProfile ? "flex-end" : "space-between"};
      margin: ${(props) => (props.isTeamProfile ? "0" : "2rem 0")};
      .teams {
        font-weight: 700;
        flex: 1;
        text-align: flex-start;
        text-decoration: none;
        color: #000;
      }
      .points-container {
        width: 40px;
        height: 60px;
        background-color: #001838;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 14px;
        margin: 0 0.5rem;
        .points {
          color: #fff;
          font-size: 20px;
          font-weight: 700;
        }
      }
      .link-container {
        a {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          text-decoration: none;
          color: black;
          font-weight: 700;
          p {
            font-size: 12px;
          }
          .right-arrow {
            width: 25px;
            margin-left: 1rem;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 867px) {
    width: ${(props) => (props.isTeamProfile ? "calc(100% )" : "100vw")};
    .gameContainer {
      width: ${(props) => (props.isTeamProfile ? "calc(100% - 30px)" : "80%")};
      flex-direction: row;
      .header {
        width: ${(props) => (props.isTeamProfile ? "45%" : "40%")};
        .league-logo {
          width: 50px;
        }
        .game-information {
          text-align: left;
          margin-left: ${(props) => (props.isTeamProfile ? "0" : "2rem")};
          flex: ${(props) => (props.isTeamProfile ? "none" : "1")};
        }
        .game-result {
          margin: 0 3rem;
          margin: ${(props) => (props.isTeamProfile ? "0" : "0 3rem")};
        }
      }

      .content {
        width: ${(props) => (props.isTeamProfile ? "45%" : "60%")};
        .link-container a {
          flex-direction: row;
          align-items: center;
          p {
            font-size: 16px;
          }
        }
        .points-container {
          width: ${(props) => (props.isTeamProfile ? "30px" : "50px")};
          height: ${(props) => (props.isTeamProfile ? "40px" : "70px")};
          .points {
            font-size: ${(props) => (props.isTeamProfile ? "15px" : "25px")};
          }
        }
      }
    }
  }
`;
